var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var apiURL = 'https://prod.api.wot.dev';
/**
 * Get cleeng ID
 * @returns default profile
 */
export var createCleengAccount = function () { return __awaiter(void 0, void 0, void 0, function () {
    var statusCode, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetch("".concat(apiURL, "/users"), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            cleengID: localStorage.getItem('CLEENG_CUSTOMER_ID'),
                        })
                    }).then(function (res) {
                        return res.json();
                    }).then(function (res) {
                        return res.statusCode;
                    })];
            case 1:
                statusCode = _a.sent();
                return [2 /*return*/, statusCode];
            case 2:
                error_1 = _a.sent();
                return [2 /*return*/, error_1];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Get profiles
 * @returns profiles
 */
export var getProfiles = function (cleengID) { return __awaiter(void 0, void 0, void 0, function () {
    var res, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetch("".concat(apiURL, "/users/").concat(cleengID), {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    }).then(function (res) {
                        return res.json();
                    }).then(function (res) {
                        return res.body;
                    })];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.profiles];
            case 2:
                error_2 = _a.sent();
                return [2 /*return*/, error_2];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Get profile
 * @returns profile
 */
export var getProfile = function (cleengID, profileID) { return __awaiter(void 0, void 0, void 0, function () {
    var res, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                console.log('profileID', profileID);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetch("".concat(apiURL, "/users/").concat(cleengID, "/").concat(profileID), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            cleengToken: localStorage.getItem('CLEENG_AUTH_TOKEN'),
                        })
                    }).then(function (res) {
                        return res.json();
                    }).then(function (res) {
                        return res.body;
                    })];
            case 2:
                res = _a.sent();
                return [2 /*return*/, res.profiles];
            case 3:
                error_3 = _a.sent();
                return [2 /*return*/, error_3];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Create profile
 * @returns statusCode
 */
export var addNewProfile = function (cleengID, addProfileModel) { return __awaiter(void 0, void 0, void 0, function () {
    var res, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetch("".concat(apiURL, "/users/").concat(cleengID), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(addProfileModel)
                    }).then(function (res) {
                        return res.json();
                    }).then(function (res) {
                        return res.statusCode;
                    })];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res];
            case 2:
                error_4 = _a.sent();
                return [2 /*return*/, error_4];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Edit profile
 * @returns statusCode
 */
export var updateProfile = function (cleengID, profileID, addProfileModel) { return __awaiter(void 0, void 0, void 0, function () {
    var res, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetch("".concat(apiURL, "/users/").concat(cleengID, "/").concat(profileID), {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(addProfileModel)
                    }).then(function (res) {
                        return res.json();
                    }).then(function (res) {
                        return res.statusCode;
                    })];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res];
            case 2:
                error_5 = _a.sent();
                return [2 /*return*/, error_5];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Delete profile
 * @returns statusCode
 */
export var deleteProfile = function (cleengID, profileID) { return __awaiter(void 0, void 0, void 0, function () {
    var res, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetch("".concat(apiURL, "/users/").concat(cleengID, "/").concat(profileID), {
                        method: 'DELETE',
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    }).then(function (res) {
                        return res.json();
                    }).then(function (res) {
                        return res.statusCode;
                    })];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res];
            case 2:
                error_6 = _a.sent();
                return [2 /*return*/, error_6];
            case 3: return [2 /*return*/];
        }
    });
}); };
